module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_purpose_home_color_skyblue-6bef8e180801136aaa72dbc18f69acc6.svg";